// extracted by mini-css-extract-plugin
export default {"textAreaInput":"TextAreaInput_textAreaInput__tW2gB"};